import { createContext, useContext } from 'react'
import type { CaptureInfo } from '../components/CaptureModal.js'

export interface CaptureContextType {
  captureQueue: CaptureInfo[]
  activeCapture: CaptureInfo | null
  captureProgress: { elapsed: number; expected: number }
  sharedStream: MediaStream | null
  startCapture: (info: CaptureInfo) => void
  clearCapture: () => void
  setSharedStream: (stream: MediaStream) => void
}

export const CaptureContext = createContext<CaptureContextType>({
  captureQueue: [],
  activeCapture: null,
  captureProgress: { elapsed: 0, expected: 0 },
  sharedStream: null,
  startCapture: () => {},
  clearCapture: () => {},
  setSharedStream: () => {},
})

export function useCapture() {
  return useContext(CaptureContext)
}
